export default __webpack_public_path__ + "static/media/manicurepo.ae16a3bc.jpg";